import Form from "@/Form";
import Modal from "@/Modal";

import "./style.css";

export default class GatedFileModal extends Modal {
  static selector = ".gated-file-modal";

  modalDidMount = async () => {
    this.formElement = this.modal.querySelector(".gated-file-modal__form");
    this.form = new Form(this.formElement, {
      onSubmitSucceeded: this.handleFormSubmitSucceeded,
      onSubmitFailed: this.handleSubmitFailed,
      resetAfterSubmit: true,
      gainControlOnSubmitSucceeded: false
    });

    this.publicationField = this.modal.querySelector(
      'input[name="publication"]'
    );
    this.fileIdField = this.modal.querySelector('input[name="fileId"]');
  };
  modalWillOpen = async () => {
    this.form.reset();
    this.modal.classList.remove("gated-file-modal--success");
  };
  modalDidUpdate = async ({ publicationId = "", fileId = "" }) => {
    this.publicationField.value = publicationId;
    this.fileIdField.value = fileId;
  };

  handleFormSubmitSucceeded = () => {
    this.modal.classList.add("gated-file-modal--success");
  };
}
